export default class TabbedCardsModule {
  constructor(context) {
    this.element = {
      buttons: context.querySelectorAll('.tabbed-card-btn'),
      name: context.querySelector('.tabbed-card-name'),
      subtext: context.querySelector('.tabbed-card-subtext'),
      description: context.querySelector('.tabbed-card-description'),
      statValue: context.querySelectorAll('.tabbed-card-stat--value'),
      source: context.querySelector('.tabbed-card-picture > source'),
      image: context.querySelector('.tabbed-card-picture > img'),
    };

    Array.from(this.element.buttons).forEach((button) => {
      button.addEventListener('click', () => {
        this.updateCopies(button);

        const medias = new Array(this.element.source, this.element.image, this.element.image),
          srcs = new Array('srcset', 'srcset', 'src');

        medias.forEach((media, index) => {
          this.updateSources(media, srcs[index], button.dataset.image);
        });

        this.updateActiveBtn(button);
      });
    });
  }

  updateActiveBtn(button) {
    document.querySelector('.tabbed-card-btn.active').classList.remove('active');
    button.classList.add('active');
  }

  updateCopies(button) {
    const { name, subtext, description } = button.dataset;

    this.element.name.innerHTML = name;
    this.element.subtext.innerHTML = subtext;
    this.element.description.innerHTML = description;

    Array.from(this.element.statValue).forEach((value, index) => (value.innerHTML = button.dataset[`stat-${index + 1}`]));
  }

  updateSources(elem, type, image) {
    const src = elem[type],
      original = src.split('&width')[0],
      updated = image.split('&width')[0];
    elem[type] = src.replaceAll(original, updated);
  }
}
